module.exports = __webpack_public_path__ + "static/media/internet_popup_img.1bdc7ac7.webp";